var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-flex",
    { attrs: { "fill-height": "" } },
    [
      _vm.selectedItem
        ? _c("item-pricing-dialog", {
            key: _vm.model.vatRate + "." + _vm.selectedItem.itemID,
            attrs: { item: _vm.selectedItem, show: _vm.itemPriceDialog },
            on: {
              "update:show": function($event) {
                _vm.itemPriceDialog = $event
              },
              ok: function($event) {
                return _vm.saveItem($event)
              }
            }
          })
        : _vm._e(),
      !_vm.embed
        ? _c(
            "v-btn",
            {
              staticClass: "text-none complete-btn v-btn--flat",
              attrs: {
                color: _vm.totalAmount > 0 ? "primary" : "error darken-2",
                height: "48px",
                block: "",
                disabled: _vm.totalAmount == 0,
                fixed: _vm.$vuetify.breakpoint.smAndDown
              },
              on: {
                click: function($event) {
                  return _vm.ok()
                }
              }
            },
            [
              _vm._v(" " + _vm._s(_vm.$t(_vm.btnText)) + " "),
              _c("ec-money", {
                staticClass: "px-1",
                attrs: {
                  amount: _vm.totalAmount,
                  currency: _vm.operationCurrency.code
                }
              })
            ],
            1
          )
        : _vm._e(),
      !_vm.embed && _vm.$vuetify.breakpoint.smAndDown
        ? _c("v-spacer", { staticStyle: { height: "48px" } })
        : _vm._e(),
      _c(
        "v-flex",
        {
          staticClass: "text-center align-stretch px-3",
          class: { white: !_vm.embed }
        },
        [
          _c(
            "v-list",
            {
              staticClass: "py-0 fill-height body-2",
              attrs: {
                "two-line": false,
                dense: true,
                subheader: "",
                color: _vm.embed ? "ecbg" : null
              }
            },
            [
              _c(
                "v-list-item",
                [
                  _c(
                    "v-list-item-content",
                    { staticClass: "text-normal" },
                    [
                      _c(
                        "v-row",
                        { attrs: { "no-gutters": "" } },
                        [
                          _c(
                            "v-col",
                            { staticClass: "text-start", attrs: { cols: "6" } },
                            [_vm._v(_vm._s(_vm.$t("Discount")))]
                          ),
                          _c(
                            "v-col",
                            { staticClass: "text-end", attrs: { cols: "6" } },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm._f("currency")(
                                    _vm.totalDiscount,
                                    _vm.operationCurrency.code
                                  )
                                )
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-list-item",
                [
                  _c(
                    "v-list-item-content",
                    { staticClass: "text-normal" },
                    [
                      _c(
                        "v-row",
                        { attrs: { "no-gutters": "", align: "center" } },
                        [
                          _c(
                            "v-col",
                            { staticClass: "text-start", attrs: { cols: "3" } },
                            [_vm._v(_vm._s(_vm.$t("VAT")))]
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "text-initial",
                              attrs: { cols: "4" }
                            },
                            [
                              _c("v-switch", {
                                staticClass: "pt-0 mt-0",
                                attrs: {
                                  disabled:
                                    this.terminalStore.settings.vatExempt ||
                                    (_vm.customer
                                      ? _vm.customer.vatExempt
                                      : false),
                                  dense: "",
                                  "hide-details": ""
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "label",
                                    fn: function() {
                                      return [
                                        _c(
                                          "span",
                                          { staticClass: "text-start" },
                                          [_vm._v(_vm._s(_vm.$t("VATExempt")))]
                                        )
                                      ]
                                    },
                                    proxy: true
                                  }
                                ]),
                                model: {
                                  value: _vm.vatExempt,
                                  callback: function($$v) {
                                    _vm.vatExempt = $$v
                                  },
                                  expression: "vatExempt"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { staticClass: "text-end", attrs: { cols: "2" } },
                            [
                              _vm._v(
                                _vm._s((_vm.model.vatRate * 100).toFixed(0)) +
                                  "%"
                              )
                            ]
                          ),
                          _c(
                            "v-col",
                            { staticClass: "text-end", attrs: { cols: "3" } },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm._f("currency")(
                                    _vm.model.vatTotal,
                                    _vm.operationCurrency.code
                                  )
                                )
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm.embed
                ? _c(
                    "v-list-item",
                    [
                      _c(
                        "v-list-item-content",
                        { staticClass: "text-normal" },
                        [
                          _c(
                            "v-row",
                            { attrs: { "no-gutters": "" } },
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "text-start",
                                  attrs: { cols: "6" }
                                },
                                [_vm._v(_vm._s(_vm.$t("Total")))]
                              ),
                              _c(
                                "v-col",
                                {
                                  staticClass: "text-end",
                                  attrs: { cols: "3" }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.model.dealDetails.items.length)
                                  )
                                ]
                              ),
                              _c(
                                "v-col",
                                {
                                  staticClass: "text-end",
                                  attrs: { cols: "3" }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("currency")(
                                        _vm.totalAmount,
                                        _vm.operationCurrency.code
                                      )
                                    )
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _c("v-divider"),
          _vm.model.dealDetails.items
            ? _c("ec-list", {
                staticClass: "pb-1",
                attrs: {
                  items: _vm.model.dealDetails.items,
                  dense: "",
                  color: _vm.embed ? "ecbg" : null
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "prepend",
                      fn: function(ref) {
                        var item = ref.item
                        var index = ref.index
                        return [
                          _c(
                            "v-btn",
                            {
                              attrs: { icon: "" },
                              on: {
                                click: function($event) {
                                  return _vm.deleteItem(index)
                                }
                              }
                            },
                            [_c("v-icon", [_vm._v("mdi-delete")])],
                            1
                          )
                        ]
                      }
                    },
                    {
                      key: "left",
                      fn: function(ref) {
                        var item = ref.item
                        return [
                          _c(
                            "v-col",
                            {
                              staticClass: "text-align-initial",
                              attrs: { cols: "12", md: "6" }
                            },
                            [
                              _c("span", { staticClass: "body-2" }, [
                                _vm._v(_vm._s(item.itemName))
                              ])
                            ]
                          ),
                          _c("v-col", {
                            staticClass: "text-align-initial",
                            attrs: { cols: "12", md: "6" }
                          })
                        ]
                      }
                    },
                    {
                      key: "right",
                      fn: function(ref) {
                        var item = ref.item
                        return [
                          _c(
                            "v-col",
                            {
                              staticClass: "text-end caption",
                              attrs: { cols: "12", md: "6", lg: "6" }
                            },
                            [
                              item.discount
                                ? _c("ec-money", {
                                    attrs: {
                                      amount: -item.discount,
                                      currency: _vm.operationCurrency.code
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass:
                                "text-end font-weight-bold subtitle-2",
                              attrs: { cols: "12", md: "6", lg: "6" }
                            },
                            [
                              item.quantity > 1
                                ? _c(
                                    "v-chip",
                                    {
                                      staticClass: "mx-1",
                                      attrs: {
                                        "x-small": "",
                                        color: "secondary"
                                      }
                                    },
                                    [_vm._v(_vm._s(item.quantity) + " ")]
                                  )
                                : _vm._e(),
                              _c("ec-money", {
                                attrs: {
                                  amount: item.price,
                                  currency: _vm.operationCurrency.code
                                }
                              })
                            ],
                            1
                          )
                        ]
                      }
                    },
                    {
                      key: "append",
                      fn: function(ref) {
                        var index = ref.index
                        return [
                          _c(
                            "v-btn",
                            {
                              attrs: { icon: "" },
                              on: {
                                click: function($event) {
                                  return _vm.editItem(index)
                                }
                              }
                            },
                            [_c("v-icon", [_vm._v("mdi-pencil")])],
                            1
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  2288693469
                )
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }